export const CompetitionForm = Object.freeze({
  Traditional: Object.freeze({
    Id: 'traditional',
    Label: 'Traditionell',
  }),
  Sprint: Object.freeze({
    Id: 'sprint',
    Label: 'Sprint',
  }),
});

export const LicenseClass = Object.freeze({
  Junior: Object.freeze({
    Id: 'junior',
    Label: 'Junior',
  }),
  Senior: Object.freeze({
    Id: 'senior',
    Label: 'Senior',
  }),
});

export const RaceClass = Object.freeze({
  Junior: Object.freeze({
    Id: 'junior',
    Label: 'Junior',
  }),
  Senior: Object.freeze({
    Id: 'senior',
    Label: 'Senior',
  }),
  Women: Object.freeze({
    Id: 'women',
    Label: 'Dam',
  }),
  Veteran: Object.freeze({
    Id: 'veteran',
    Label: 'Veteran',
  }),
  FWD: Object.freeze({
    Id: 'fwd',
    Label: 'Fwd',
  }),
  RWD: Object.freeze({
    Id: 'rwd',
    Label: 'Rwd',
  }),
});
